import styled from 'styled-components';

export const StyledSelectable = styled.div`
  background: #fff;
  border: 1px ${props => props.theme.colors.border} solid;
  padding: 30px;
  border-radius: ${props => props.theme.borderRadius};
  cursor: pointer;
  position: relative;

  .check {
    height: 20px;
    width: 20px;
    border: 1px ${props => props.theme.colors.border} solid;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: ${props => props.theme.fontSizes.extraSmall};
    border-radius: 100%;
    position: absolute;
    top: 15px;
    right: 15px;

    svg {
      display: none;
    }
  }

  &.current {
    box-shadow: inset 0px 0px 0px 1px ${props => props.theme.colors.primary};
    border-color: ${props => props.theme.colors.primary};

    .check {
      background: ${props => props.theme.colors.primary};
      border-color: ${props => props.theme.colors.primary};
      color: #fff;

      svg {
        display: block;
      }
    }
  }
`
